export const DEFAULT_LABEL_UPLOAD = "免許証写真アップロード";
export const HEADER_TITLE_POST_CODE = "郵便番号を入力する";
export const HEADER_TITLE_CHECK_LOTTERY = "抽選結果確認";
export const HEADER_TITLE_PREMIUM_BENEFITS = "プレミアム商品券";
export const HEADER_TITLE_VOUCHER_LIST = "商品券一覧";
export const HEADER_TITLE_REGISTER_LOTTERY = "お客様情報";
export const HEADER_TITLE_PAYMENT = "決済手続き";
export const HEADER_TITLE_FURUSATO_SEARCH_PAYMENT = "クーポン詳細";
export const HEADER_TITLE_VOUCHER_SEARCH_PAYMENT = "クーポン詳細";
export const MESSAGE_ERROR_SCAN_QR_CODE = "コードが存在しません";
export const SUCCESS = "成功";
export const MAX_FILE_SIZE = 5024;
export const MESSAGE_ERROR_SYSTEM = "データの表示が失敗しました";
export const UPDATE_SUCCESS = "正常に更新しました";
export const UPDATE_FAIL = "更新が失敗しました";
export const UPDATE_PASSWORD_FAIL = "現在のパスワードが異なります";
export const INVALID_VALUE = "入力した値は正しくありません。";
export const EMPTY_MESSAGE = "データがありません";
export const MIN_MAX = "最小値より大きい最大値を入力してください。";
export const WARNING_SOLD_OUT_MESSAGE = "販売終了";
// export const POST_CODE_NOT_EXIST = "該当の郵便番号がありません";
export const POST_CODE_NOT_EXIST =
  "郵便番号が存在しないか、イベントが発生しませんでした";
export const TOP_CHECK_LOTTERY = "抽選結果確認";
export const TOP_REGISTER_LOTTERY = "申込はこちら";
export const TOP_LIST_STORE = "利用可能店舗";
export const TOP_LOGIN_TO_BUY_COUPON = "ログインしてチケットを購入";
export const TOP_BUY_COUPON = "チケットの購入";
export const VOUCHER_DETAIL_TITLE = "商品券詳細";
export const MESSAGE_ERRORS_COMMON = {
  fieldRequired: "必須項目です",
};

export const MESSAGE_ERRORS_USER = {
  requirePhone: "最低１つの電話番号の入力が必須です",
  formatPhone: "電話番号の形式が正しくありません",
  formatEmail: "有効なメールアドレスを入力してください",
};

export const MESSAGE_ERRORS_PAYMENT = {
  formatCardNumber: "カード番号の形式が正しくありません",
  securityCodeOnlyNumber: "セキュリティコードは数字ではなければなりません",
  formatExpirationDate: "有効期限の形式が正しくありません。",
  wrongImage: "JPGまたはPNGファイルしかアップロードできません",
  titleConfirmPayment:
    "お支払い情報の登録が完了しました。支払い手続きを進めてもよろしいでしょうか。",
  errosMessagesPaymentFailed: "支払いに失敗しました。",
  formatCCV: "セキュリティコードの形式が正しくありません",
};

export const MESSAGE_OCR = {
  compareSuccess: "データが一致しました",
  nameNotMatch: "名前が一致していません",
  addressNotMatch: "住所が一致していません",
  maxFileSize: "ファイルのサイズが5024KBを超えてはいけません",
  messageCommon: "以下のフィールドの認証に失敗しました。",
};

export const MESSAGE_ERRORS_TOP = {
  postCodeOnlyNumber: "ハイフン無し7桁で入力してください",
  postCodeMin: "ハイフン無し7桁で入力してください",
  passwordMin: "8文字以上の英数字を入力してください",
};

export const MESSAGE_ERROR_SCAN = {
  valueInvalid: "Data scan is invalid",
  giftIdInvalid: "Value Gift ID is invalid",
  groupIdInvalid: "Value Group ID is invalid",
};

export const MESSAGE_ERROR_HISTORY = {
  listHistory: "Fail to load history list",
  groupIdInvalid: "グループが存在しません",
};

export const MESSAGE_ERRORS_DATE = {
  expirationDateWrong: (date: string) => {
    return `有効期限は ${date} 以上で入力してください。`;
  },
};

export const FIELD_FROM_DATA_SERVER = {
  POST_CODE_TITLE: "input_postcode_title_key",
  GIFT_VOUCHER_TITLE: "list_voucher_title_key",
  GIFT_VOUCHER_DETAIL_TITLE: "voucher_detail_title_key",
  TOP_TITLE: "top_title_key",
  REGISTER_TITLE: "register_title_key",
  TOP_BUTTON_1: "top_btn1_key",
  TOP_BUTTON_2: "top_btn2_key",
  TOP_STORE: "top_store_key",
  TOP_REGISTER_LOTTERY: "top_register_lottery_key",
  TOP_CHECK_LOTTERY: "top_check_lottery_key",
  TOP_BUY_VOUCHER: "top_buy_voucher_key",
  TOP_LOGIN: "top_login_key",
  PAYMENT_TITLE: "payment_title_key",
  USE_COUPON_TITLE: "use_coupon_title_key",
  LIST_COUPON_TITLE: "list_coupon_title_key",
  SUCCESS_NOTIFICATION_TITLE: "thankyou_title_key",
  SUCCESS_NOTIFICATION_TEXT: "thankyou_text_key",
  SUCCESS_NOTIFICATION_BTN2: "thankyou_btn_furusato_key",
  HISTORY_TITLE: "history_title_key",
  HISTORY_BUTTON_1: "history_btn1_key",
  HISTORY_BUTTON_2: "history_btn2_key",
  HISTORY_DETAIL_TITLE: "use_coupon_detail_title_key",
  USER_INFO_TITLE: "user_info_title_key",
  ONE_STOP_TITLE: "one_stop_title_key",
  SCAN_QR_TITLE: "scan_QR_title_key",
  QA_TITLE: "qa_title_key",
  SUCCESS_USE_TITLE: "use_coupon_success_title_key",
  SUCCESS_USE_TEXT: "use_coupon_success_text_key",
  WHAT_IS_TITLE: "what_is_title_key",
  WHAT_IS_MENU_BOT: "what_is_btn1_key",
  VOUCHER_BUTTON_1: "voucher_btn1_key",
  VOUCHER_BUTTON_2: "voucher_btn2_key",
};
